export default {
    'zh_CN': {
        'common.sys-dict-typ.id.label': '主键ID',
        'common.sys-dict-typ.id.holder': '请输入主键ID',
        
        
        'common.sys-dict-typ.id.required': '主键ID必填',
        'common.sys-dict-typ.sign.label': '字典类型',
        'common.sys-dict-typ.sign.holder': '请输入字典类型',
        'common.sys-dict-typ.sign.max': '字典类型最多100个字符',
        
        'common.sys-dict-typ.sign.required': '字典类型必填',
        'common.sys-dict-typ.label.label': '字典名称',
        'common.sys-dict-typ.label.holder': '请输入字典名称',
        'common.sys-dict-typ.label.max': '字典名称最多100个字符',
        
        'common.sys-dict-typ.label.required': '字典名称必填',
        'common.sys-dict-typ.status.label': '状态',
        'common.sys-dict-typ.status.holder': '请输入状态',
        
        
        'common.sys-dict-typ.status.dictionary': ()=>[{value:0,label:'禁用'},{value:1,label:'启用'}],
        'common.sys-dict-typ.status.required': '状态必填',
        'common.sys-dict-typ.remark.label': '备注',
        'common.sys-dict-typ.remark.holder': '请输入备注',
        'common.sys-dict-typ.remark.max': '备注最多500个字符',
        
        'common.sys-dict-typ.remark.required': '备注必填',
        'common.sys-dict-typ.createTime.label': '创建时间',
        'common.sys-dict-typ.createTime.holder': '请输入创建时间',
        'common.sys-dict-typ.createTime.required': '创建时间必填',
        'common.sys-dict-typ.updateTime.label': '更新时间',
        'common.sys-dict-typ.updateTime.holder': '请输入更新时间',
        'common.sys-dict-typ.updateTime.required': '更新时间必填',
        'common.sys-dict-typ.deleted.label': '是否删除',
        'common.sys-dict-typ.deleted.holder': '请输入是否删除',
        'common.sys-dict-typ.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'common.sys-dict-typ.id.label': '主键ID',
        'common.sys-dict-typ.id.holder': '請輸入主键ID',
        
        
        'common.sys-dict-typ.id.required': '主键ID必填',
        'common.sys-dict-typ.sign.label': '字典类型',
        'common.sys-dict-typ.sign.holder': '請輸入字典类型',
        
        
        'common.sys-dict-typ.sign.required': '字典类型必填',
        'common.sys-dict-typ.label.label': '字典名称',
        'common.sys-dict-typ.label.holder': '請輸入字典名称',
        
        
        'common.sys-dict-typ.label.required': '字典名称必填',
        'common.sys-dict-typ.status.label': '状态',
        'common.sys-dict-typ.status.holder': '請輸入状态',
        
        
        'common.sys-dict-typ.status.required': '状态必填',
        'common.sys-dict-typ.remark.label': '备注',
        'common.sys-dict-typ.remark.holder': '請輸入备注',
        
        
        'common.sys-dict-typ.remark.required': '备注必填',
        'common.sys-dict-typ.createTime.label': '创建时间',
        'common.sys-dict-typ.createTime.holder': '請輸入创建时间',
        
        
        'common.sys-dict-typ.createTime.required': '创建时间必填',
        'common.sys-dict-typ.updateTime.label': '更新时间',
        'common.sys-dict-typ.updateTime.holder': '請輸入更新时间',
        
        
        'common.sys-dict-typ.updateTime.required': '更新时间必填',
        'common.sys-dict-typ.deleted.label': '是否删除',
        'common.sys-dict-typ.deleted.holder': '請輸入是否删除',
        
        
        'common.sys-dict-typ.deleted.required': '是否删除必填'
    },
    'en_US': {
        'common.sys-dict-typ.id.label': 'id',
        'common.sys-dict-typ.id.holder': 'Enter id',
        'common.sys-dict-typ.id.max': 'id max length: 主键ID',
        
        
        'common.sys-dict-typ.id.required': 'id required',
        'common.sys-dict-typ.sign.label': 'sign',
        'common.sys-dict-typ.sign.holder': 'Enter sign',
        'common.sys-dict-typ.sign.max': 'sign max length: 字典类型',
        
        
        'common.sys-dict-typ.sign.required': 'sign required',
        'common.sys-dict-typ.label.label': 'label',
        'common.sys-dict-typ.label.holder': 'Enter label',
        'common.sys-dict-typ.label.max': 'label max length: 字典名称',
        
        
        'common.sys-dict-typ.label.required': 'label required',
        'common.sys-dict-typ.status.label': 'status',
        'common.sys-dict-typ.status.holder': 'Enter status',
        'common.sys-dict-typ.status.max': 'status max length: 状态',
        
        
        'common.sys-dict-typ.status.required': 'status required',
        'common.sys-dict-typ.remark.label': 'remark',
        'common.sys-dict-typ.remark.holder': 'Enter remark',
        'common.sys-dict-typ.remark.max': 'remark max length: 备注',
        
        
        'common.sys-dict-typ.remark.required': 'remark required',
        'common.sys-dict-typ.createTime.label': 'createTime',
        'common.sys-dict-typ.createTime.holder': 'Enter createTime',
        'common.sys-dict-typ.createTime.max': 'createTime max length: 创建时间',
        
        
        'common.sys-dict-typ.createTime.required': 'createTime required',
        'common.sys-dict-typ.updateTime.label': 'updateTime',
        'common.sys-dict-typ.updateTime.holder': 'Enter updateTime',
        'common.sys-dict-typ.updateTime.max': 'updateTime max length: 更新时间',
        
        
        'common.sys-dict-typ.updateTime.required': 'updateTime required',
        'common.sys-dict-typ.deleted.label': 'deleted',
        'common.sys-dict-typ.deleted.holder': 'Enter deleted',
        'common.sys-dict-typ.deleted.max': 'deleted max length: 是否删除',
        
        
        'common.sys-dict-typ.deleted.required': 'deleted required'
    }
}
